<template>
  <cst-page-template :hide-menu="true" class="quote-overview-page">
    <header-menu />
    <pcqm-dashboard-warning-container />

    <quote-overview-header />

    <!--
      TODO CST-2982
      This tabs component is tied directly to the index instead of going over a key
      For the new stock flow it is easier to duplicate and remove than rework this.
    -->
    <tabs
      v-if="isTest && dealerSettings.newStockFlowEnabled"
      :preselected-index="preselectedIndex"
      :tab-names="tabNames"
      @select-tab="onTabSelected"
    >
      <tab :title="'Voorraad (New)'" :index="0">
        <stock-dashboard-new />
      </tab>
      <tab :title="i18n.t('/StockDashboard/Headers/Tab Title')" :index="1">
        <stock-dashboard />
      </tab>
      <tab :title="i18n.t('/Dashboard/Headers/Tab Title')" :index="2">
        <quote-overview v-if="establishmentId" :establishment-id="establishmentId" />
      </tab>
      <tab v-if="hasApprovalTab" :title="'Beoordelen'" :index="3">
        <manager-approval-overview v-if="establishmentId" :establishment-id="establishmentId" />
      </tab>
    </tabs>

    <tabs
      v-else
      :preselected-index="preselectedIndex"
      :tab-names="tabNames"
      @select-tab="onTabSelected"
    >
      <tab :title="i18n.t('/StockDashboard/Headers/Tab Title')" :index="0">
        <stock-dashboard-new v-if="dealerSettings.newStockFlowEnabled" />
        <stock-dashboard v-else />
      </tab>
      <tab :title="i18n.t('/Dashboard/Headers/Tab Title')" :index="1">
        <quote-overview v-if="establishmentId" :establishment-id="establishmentId" />
      </tab>
      <tab v-if="hasApprovalTab" :title="'Beoordelen'" :index="2">
        <manager-approval-overview v-if="establishmentId" :establishment-id="establishmentId" />
      </tab>
    </tabs>
  </cst-page-template>
</template>

<script>
import CstPageTemplate from '@/templates/CstPageTemplate.vue'
import QuoteOverviewHeader from '@/components/generic/presentational/organisms/quoteOverview/QuoteOverviewHeader.vue'
import QuoteOverview from '@/components/generic/presentational/organisms/quoteOverview/QuoteOverview.vue'
import StockDashboard from '@/components/generic/presentational/organisms/stockDashboard/StockDashboard.vue'
import Tabs from '@/components/generic/presentational/molecules/tabs/Tabs.vue'
import Tab from '@/components/generic/presentational/molecules/tabs/Tab.vue'
import PcqmDashboardWarningContainer from '@/components/generic/presentational/molecules/pcqmDashboardWarningContainer/PcqmDashboardWarningContainer.vue'
import establishmentsService from '@/services/establishmentsService.js'
import StockDashboardNew from '@/components/generic/presentational/organisms/stockDashboardNew/StockDashboardNew.vue'
import ManagerApprovalOverview from '@/components/generic/presentational/organisms/managerApproval/ManagerApprovalOverview.vue'
import { mapGetters } from 'vuex'
import HeaderMenu from '@/components/generic/presentational/molecules/headerMenu/HeaderMenu.vue'

export default {
  name: 'QuoteOverviewPage',
  components: {
    StockDashboardNew,
    CstPageTemplate,
    QuoteOverviewHeader,
    QuoteOverview,
    StockDashboard,
    Tabs,
    Tab,
    PcqmDashboardWarningContainer,
    HeaderMenu,
    ManagerApprovalOverview,
  },
  props: {
    establishmentId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
  computed: {
    ...mapGetters({
      dealerSettings: 'user/dealerSettings',
      canGetApprovalQueue: 'user/canGetApprovalQueue',
    }),
    preselectedIndex() {
      const tabParam = this.$route.query.tab
      if (tabParam !== undefined) {
        const tabIndex = parseInt(tabParam, 10)
        // Validate that the tab index is within bounds
        if (!isNaN(tabIndex) && tabIndex >= 0 && tabIndex < this.tabNames.length) {
          return tabIndex
        }
      }

      // Default behavior: find the "Offertes" tab
      const defaultTabName = this.i18n.t('/Dashboard/Headers/Tab Title')
      return this.tabNames.findIndex((name) => name === defaultTabName)
    },
    tabNames() {
      const tabs = []

      if (this.isTest && this.dealerSettings.newStockFlowEnabled) {
        tabs.push('Voorraad (New)')
      }

      tabs.push(this.i18n.t('/StockDashboard/Headers/Tab Title'))
      tabs.push(this.i18n.t('/Dashboard/Headers/Tab Title'))

      if (this.dealerSettings.salesApprovalEnabled && this.canGetApprovalQueue) {
        tabs.push('Beoordelen')
      }

      return tabs
    },
    hasApprovalTab() {
      return this.dealerSettings.salesApprovalEnabled && this.canGetApprovalQueue
    },
    isTest() {
      return this.$route.query?.hasOwnProperty('isTest')
    },
  },
  async created() {
    // no establishmentId provided, pick the first
    if (!this.establishmentId) {
      if (this.$store.state.establishments.length > 0) {
        this.addEstablishmentIdToUrl(
          this.$store.state.establishments.establishments[0].EstablishmentNumber
        )
      } else {
        await establishmentsService.getEstablishments().then((response) => {
          this.addEstablishmentIdToUrl(
            this.$store.state.establishments.establishments[0].EstablishmentNumber
          )
        })
      }
    }
  },
  methods: {
    addEstablishmentIdToUrl(establishmentId) {
      this.$router.push({
        name: 'quote-overview-page',
        params: {
          establishmentId: establishmentId,
          cstType: this.$route.params.cstType,
        },
        query: this.$route.query,
      })
    },
    onTabSelected(tabIndex) {
      // Update the URL to reflect the currently selected tab
      const currentQuery = { ...this.$route.query }

      // Update or add the tab parameter
      currentQuery.tab = tabIndex

      // Navigate to the same route with updated tab parameter
      this.$router.replace({
        name: this.$route.name,
        params: this.$route.params,
        query: currentQuery,
      })
    },
  },
}
</script>

<style lang="scss" scoped></style>
